var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "curriculum-page" },
    [
      _c("div", { staticClass: "cross" }, [
        _c(
          "div",
          { staticClass: "fixed-table" },
          [_c("CurriculumTable", { attrs: { list: _vm.list } })],
          1
        ),
        _c(
          "div",
          { staticClass: "body-table" },
          [
            _c("CurriculumTable", {
              attrs: { list: _vm.list },
              on: { openSchedule: _vm.openSchedule },
            }),
          ],
          1
        ),
      ]),
      _c(
        "van-dialog",
        {
          class:
            _vm.screenType == 0
              ? "curriculum-heng-dialog"
              : "curriculum-shu-dialog",
          attrs: {
            "show-confirm-button": false,
            "show-cancel-button": false,
            "close-on-click-overlay": true,
            "get-container": "#app",
          },
          model: {
            value: _vm.showDialog,
            callback: function ($$v) {
              _vm.showDialog = $$v
            },
            expression: "showDialog",
          },
        },
        [
          _vm.screenType == 0
            ? _c(
                "div",
                {
                  staticClass: "curriculum-dialog-closebutton",
                  on: {
                    click: function ($event) {
                      _vm.showDialog = false
                    },
                  },
                },
                [_c("span", { staticClass: "iconfont icon-icon_wrong" })]
              )
            : _vm._e(),
          _vm.showDialog
            ? _c("one-week-schedule", {
                ref: "oneWeekSchedule",
                attrs: { openClass: _vm.openClass },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }